// 是否是excel
export const isExcel = (file) => {
  return /\.(xlsx|xls)$/.test(file.name);
};

// 是否是空对象
export const isEmpty = (obj) => {
  return Reflect.ownKeys(obj).length === 0 && obj.constructor === Object;
};
